import { BaseModel } from '../base-model';

export interface IPropertyCreativeObject {
    PurposeId?: number;
    CategoryTypeId?: number;
    IsAnnuity?: boolean;
    StatusId?: number;
}
export class PropertyCreativeObject extends BaseModel<IPropertyCreativeObject> implements IPropertyCreativeObject {
    PurposeId?: number;
    CategoryTypeId?: number;
    IsAnnuity?: boolean;
    StatusId?: number;
    /**
     *
     */
    constructor(option?: IPropertyCreativeObject) {
        super(option)
    }
}